var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99533 0.566648C6.14574 0.565778 6.29484 0.594607 6.43408 0.651481C6.57333 0.708355 6.69997 0.792155 6.80676 0.898077L11.3782 5.46951C11.5934 5.68471 11.7143 5.97659 11.7143 6.28093C11.7143 6.58528 11.5934 6.87716 11.3782 7.09236C11.163 7.30757 10.8711 7.42847 10.5668 7.42847C10.2624 7.42847 9.97054 7.30757 9.75533 7.09236L5.99533 3.32093L2.23533 7.08093C2.0167 7.26816 1.73547 7.366 1.44784 7.35489C1.16021 7.34378 0.887368 7.22454 0.683832 7.02101C0.480295 6.81747 0.36106 6.54462 0.34995 6.25699C0.33884 5.96937 0.436674 5.68814 0.623904 5.46951L5.19533 0.898077C5.4082 0.68694 5.69552 0.56791 5.99533 0.566648Z",
    fill: "#1C75BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDropdown);
export default __webpack_public_path__ + "static/media/closeDropdown.4d3ab80a7035ed0e5b1c1429e4b9e3f7.svg";
export { ForwardRef as ReactComponent };